import React, { useState } from "react"
import PropTypes from "prop-types"
import {
  ButtonGroup,
  ButtonGroupButton,
  useRadioGroup,
  useBreakpointValue,
} from "datastory-shared/ui"
import { logEvent } from "datastory-shared/utils/analytics"

const XDomainUI = ({
  xDomain,
  xDomains,
  onXDomainChange,
  isCompleteDataLoaded,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const buttonSize = useBreakpointValue(["sm", "md"])

  const { getRootProps, getRadioProps } = useRadioGroup({
    name: "poll-of-polls-sweden",
    defaultValue: xDomains.find(i => i.id == xDomain).id,
  })

  const group = getRootProps({
    onChange: async event => {
      const id = xDomains.find(i => i.id === event.target.value).id
      if (!isCompleteDataLoaded && id === "complete") setIsLoading(true)
      await onXDomainChange(id)
      setIsLoading(false)
      logEvent("Interactives", `Changed domain: ${id}`, "PollOfPollsSweden")
    },
  })

  return (
    <ButtonGroup {...group}>
      {xDomains.map(({ id, label }) => {
        const radio = getRadioProps({ value: id })
        return (
          <ButtonGroupButton
            key={id}
            size={buttonSize}
            isLoading={id === "complete" && isLoading}
            mr="2px"
            {...radio}
          >
            {label}
          </ButtonGroupButton>
        )
      })}
    </ButtonGroup>
  )
}

XDomainUI.propTypes = {
  xDomains: PropTypes.array.isRequired,
  xDomain: PropTypes.string.isRequired,
  onXDomainChange: PropTypes.func.isRequired,
  isCompleteDataLoaded: PropTypes.bool,
}

export default XDomainUI
